module.exports = __webpack_public_path__ + "static/media/t8.0b7e20ab.png";